import { useRef, useEffect } from 'react';

export const useValueRef = (value) => {
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  return valueRef;
};
